import  {request}  from './request';
const BASE = '/statements'
const BASE2 = '/admin'
// 获取目标/保底数据
export const getAmountConfig = (data) => {
    return request(`${BASE}/Exhibition_Analysis/getdata`,"post",data)
}
// 测算
export const getManualAmount = (data) => {
    return request(`${BASE}/Exhibition_Analysis/getManualAmount`,"post",data)
}
// 目标测算
export const getRecommendStrategy = (data) => {
    return request(`${BASE}/Exhibition_Analysis/getRecommendStrategy`,"post",data)
}
// 保底测算
export const getbdRecommendStrategy = (data) => {
    return request(`${BASE}/Exhibition_Analysis/getbdRecommendStrategy`,"post",data)
}
// 获取筛选项
export const selectlist = (data) => {
    return request(`${BASE}/Exhibition_Analysis/selectlist`,"post",data)
}
// 查看款式
export const goodslist = (data) => {
    return request(`${BASE}/Exhibition_Analysis/goodslist`,"post",data)
}
// 销售分析
export const getkzd = (data) => {
    return request(`${BASE}/kzd/getkzd`,"post",data)
}
// 销售获取筛选项
export const getSaleSelectlist = (data) => {
    return request(`${BASE}/kzd/selectlist`,"post",data)
}
// 
export const get_eos_arqxs_data = (data) => {
    return request(`${BASE}/Exhibition_Analysis/get_eos_arqxs_data`,"post",data)
}
export const get_eos_mrkc_data = (data) => {
    return request(`${BASE}/Exhibition_Analysis/get_eos_mrkc_data`,"post",data)
}
/**
 * 展厅客户分析明细
 */
// 获取筛选项/数据时间
export const getfilteroption = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/getfilteroption`,"post",data)
}
// 获取年份/月份
export const getdate = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/getdate`,"post",data)
}
// 点击客号数量查看客号列表
export const cuslist = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/cuslist`,"post",data)
}
// 获取列表
export const itemlist = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/itemlist`,"post",data)
}
// 获取客号
export const search_cus = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/search_cus`,"post",data)
}
/**柜台 */
// 获取数据
export const getCounterData = (data) => {
    return request(`${BASE}/gt_Exhibition_Analysis/getdata`,"post",data)
}
/**
 * 业务
 */
// 获取数据
export const getBusinessData = (data) => {
    return request(`${BASE}/yw_Exhibition_Analysis/getdata`,"post",data)
}
/**
 * 重点客户
 */
// 重点客户分析-获取目标-完成率
export const key_cus_header = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/key_cus_header`,"post",data)
}
// 重点客户分析-客户列表
export const key_cus_list = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/key_cus_list`,"post",data,'json',data.signal)
}
// 重点客户分析-品类明细
export const cus_wpfl = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/cus_wpfl`,"post",data)
}
// 保底
export const newbdapi = (data) => {
    return request(`${BASE}/Exhibition_Analysis/newbdapi`,"post",data)
}
// 重点客户分析-款式明细
export const cus_goods = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/cus_goods`,"post",data)
}
// 重点客户分析-费用明细
export const get_expense = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/get_expense`,"post",data)
}
// 重点客户分析-毛利明细
export const cus_ml = (data) => {
    return request(`${BASE2}/Eosexhibitioncusanalysis/cus_ml`,"post",data)
}
// 重点客户分析-款号明细
// export const cus_goods = (data) => {
//     return request(`${BASE2}/Eosexhibitioncusanalysis/cus_goods`,"post",data)
// }